import React from 'react';
import styled, { css } from 'styled-components';
import { Button as MenuButton, openMenu, closeMenu, } from 'react-aria-menubutton';
import { v4 as uuid } from 'uuid';
import { muiBankTheme } from '../tools/theme';
import DropdownMenuContext from './DropdownMenuContext';
import { addAllyTM } from '../tools/utils';
import { stylesBySize as buttonStylesBySize } from '../Action/shared/utils';
const StyledMenuButton = styled(MenuButton) `
  ${({ $asButton, variant = 'primary' }) => $asButton ? css(muiBankTheme.buttons[variant]) : css ``}

  ${({ $asButton }) => ($asButton ? buttonStylesBySize.sm : css ``)}
`;
const Trigger = React.forwardRef(({ className, id, content, ariaLabel: getAriaLabel = (isOpen) => isOpen ? 'Close Menu' : 'Open Menu', asButton, disabled, variant = 'primary', withAllyTM = true, }, ref) => {
    const { current: btnUUID } = React.useRef(uuid());
    const { wrapperId, isOpen } = React.useContext(DropdownMenuContext);
    const dataTrackState = isOpen ? 'open' : 'closed';
    const asButtonProps = () => {
        if (!asButton)
            return {};
        const safeId = id || `${variant}-button-${btnUUID}`;
        const allyTM = addAllyTM({
            content,
            id: safeId,
            elementType: 'interactive',
            withAllyTM,
        });
        return Object.assign({ disabled,
            variant, tag: 'button' }, allyTM);
    };
    return (React.createElement(StyledMenuButton, Object.assign({ className: className, id: id, "$asButton": !!asButton, "aria-label": getAriaLabel(isOpen), "data-track-state": dataTrackState, onClick: () => {
            /**
             *  The reason for this onClick override is that the default option for
             *  focusMenu is false. We need to focus on the first element in the
             *  menu after the menu is opened to comply with ARIA accessibility standards.
             *  If react-aria-menubutton gets updated to not use the legacy Context API
             *  (which there's currently a PR for), then we won't need to generate a
             *  wrapperId and will be able to use this instead:
             *
             *
             *  ambManager.toggleMenu({}, { focusMenu: false });
             **/
            // closeMenu will only execute on mobile VoiceOver due to the difference
            // between reading and tabbing
            return isOpen
                ? closeMenu(wrapperId, { focusButton: true })
                : openMenu(wrapperId, { focusMenu: true });
        }, ref: ref }, asButtonProps()), content));
});
export default Trigger;
//# sourceMappingURL=Trigger.js.map